import { Button, Col, PageHeader, Row, notification } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import React, { useState } from "react";
import { PermissionsTable } from "./PermissionsTable";
import { PermissionsExport } from "./PermissionsExport";
import { PermissionAddition } from "../../../components/Permissions";
import { PermissionsImport } from "./PermissionsImport";

export function PermissionsList() {

  const [additionOpen, setAdditionOpen] = useState(false);
  const [exportOpen, setExportOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  function handleOnAdditionOpen() {
    setAdditionOpen(true);
  }

  function handleOnAdditionCancel() {
    setAdditionOpen(false);
  }

  function handleOnAdditionOk() {
    setAdditionOpen(false);
    notification.success({
      message: 'Разрешение добавлено'
    })
  }

  function handleOnExportOpen() {
    setExportOpen(true);
  }

  function handleOnImportOpen() {
    setImportOpen(true);
  }

  function handleOnExportCancel() {
    setExportOpen(false);
  }

  function handleOnImportCancel() {
    setImportOpen(false);
  }

  function handleOnExportOk() {
    setExportOpen(false);
    notification.success({
      message: 'Экспорт выполнен'
    })
  }

  function handleOnImportOk() {
    setImportOpen(false);
    notification.success({
      message: 'Импорт выполнен'
    })
  }

  return (
    <>
      <PageHeader
        title='Разрешения'
        extra={(
          <Row gutter={8} style={{ marginBottom: '1rem' }}>
            <Col>
              <Button onClick={handleOnExportOpen}>
                Экспорт
              </Button>
            </Col>
            <Col>
              <Button onClick={handleOnImportOpen}>
                Импорт
              </Button>
            </Col>
            <Col>
              <Button type='primary' icon={<PlusOutlined />} onClick={handleOnAdditionOpen}>
                Добавить
              </Button>
            </Col>
          </Row>
        )}
      />
      <PermissionsTable />
      <PermissionAddition
        open={additionOpen}
        onOk={handleOnAdditionOk}
        onCancel={handleOnAdditionCancel}
      />
      <PermissionsExport
        open={exportOpen}
        onOk={handleOnExportOk}
        onCancel={handleOnExportCancel}
      />
      <PermissionsImport
        open={importOpen}
        onOk={handleOnImportOk}
        onCancel={handleOnImportCancel}
      />
    </>
  )
}